import { TFormStoreData } from '../../../types/form';
import { TStepsMap } from '../types/internal';

export const getStepsMap = (formData: TFormStoreData) =>
  formData.schema.steps.reduce(
    (map, step) => ({
      ...map,
      [step.code]: step,
    }),
    {} as TStepsMap,
  );
